import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Currency } from '@app/model/currency';
import {
  LineItem,
  Market,
} from '@app/model/payment-request/payment-request.dto';
import { FiUserService } from '@app/service/fi-user-service/fi-user.service';
import {
  BaseStateLocaleCode,
  CheckoutCustomizations,
} from '@app/service/state/state.service';

@Component({
  selector: 'app-payment-request-info',
  templateUrl: './payment-request-info.component.html',
  styleUrls: ['./payment-request-info.component.scss'],
})
export class PaymentRequestInfoComponent implements OnInit {
  @Input() lineItems: LineItem[];
  @Input() market: Market;
  @Input() value: Currency;
  @Input() language: string;
  @Input() isButtonDisabled: boolean;
  @Input() isButtonLoading: boolean;
  @Input() buttonText: string;
  @Input() buttonLogo: string;
  @Input() merchantCustomization: CheckoutCustomizations;
  @Output() onDetailsClick = new EventEmitter();
  @Output() onContinueClick = new EventEmitter();

  detailsLabel: string;
  amountLabel: Currency;
  hasLineItems: boolean;
  detailsText: string;

  constructor(private fiUserService: FiUserService) {}

  ngOnInit(): void {
    this.hasLineItems = this.lineItems?.length > 0;
    this.amountLabel = this.value;

    switch (this.market) {
      case Market.SE:
        this.detailsLabel = 'Visa detaljer';
        this.detailsText = this.hasLineItems
          ? 'Totalbelopp inkl. moms'
          : 'Totalt belopp';
        break;
      case Market.AT:
      case Market.DE:
        this.detailsLabel = 'Details anzeigen';
        this.detailsText = this.getMerchantDetailsText();
        break;
      case Market.NO:
        this.detailsLabel = 'Vis detaljer';
        this.detailsText = 'Totalbeløp';
        break;
      case Market.FI:
        if (
          this.fiUserService.getCurrentStateLocaleBaseCode(this.language) ===
          BaseStateLocaleCode.EN
        ) {
          this.detailsLabel = 'Show details';
          this.detailsText = 'Total amount';
          break;
        }

        this.detailsLabel = 'Näytä tiedot';
        this.detailsText = 'Kokonaissumma sis. ALV';
        break;
    }
  }

  getMerchantDetailsText(): string {
    let merchantDetailsText = 'Gesamtbetrag';

    if (this.hasLineItems) {
      merchantDetailsText += this.merchantCustomization?.merchantTaxTypeText
        ? ` inkl. ${this.merchantCustomization.merchantTaxTypeText}`
        : ' inkl. MwSt';
    }

    return merchantDetailsText;
  }

  detailsClick(): void {
    this.onDetailsClick.emit();
  }

  continueClick(): void {
    this.onContinueClick.emit();
  }
}
